import React from "react"
import { Icon, Label } from "semantic-ui-react"
import ProductModelBase from "theme/base/shop/ProductModel"

export default class ProductModelTrendimport extends ProductModelBase {
  constructor( data ) {
    super( data )
  }

  // /**
  //  *
  //  * @param size : Number
  //  * @param currentStock : Number
  //  * @returns {*}
  //  */
  // getNotice = ( size, currentStock = false ) => {
  //   let notice = <Label color={"green"}><Icon name={"truck"}/>Auf Lager</Label>
  //
  //   if ( size === "tiny" ) {
  //     notice = <Icon name={"truck"} color={"green"}/>
  //
  //   }
  //   return notice
  // }

}



// WEBPACK FOOTER //
// ./src/theme/trendimport/shop/ProductModel.js